import { createSlice } from "@reduxjs/toolkit"
import { REQUEST_STATUS, ERROR_CODE, ACCOUNT_INFO_URL } from "../../app/constants"
import { setLoginExpired } from "./nsLoginSlice"

const userAuthSlice = createSlice({
    name : 'userAuth',
    initialState : {
        userData : null,
        csrfToken : null,
        requestStatus : REQUEST_STATUS.IDLE 
    },
    reducers : {
        setUserData(state, action) { 
            state.userData = action.payload
        }, 
        setCsrfToken(state, action) { 
            state.csrfToken = action.payload
        },
        setAccountInfoRequestStatus(state, action) { 
            state.requestStatus = action.payload
        }
    }
})

export const {
    setUserData, 
    setCsrfToken,
    setAccountInfoRequestStatus
} = userAuthSlice.actions

export const getAccountInfo = () => async (dispatch, getState) => {

    if(getState().userAuth.requestStatus === REQUEST_STATUS.IN_PROGRESS) { 
        return Promise.reject(ERROR_CODE.REQUEST_OUTSTANDING)
    }

    const csrfTokenHeader = "x_csrf_token"
    dispatch(setAccountInfoRequestStatus(REQUEST_STATUS.IN_PROGRESS))
    return fetch(ACCOUNT_INFO_URL,{method : "GET"})
            .then((resp) => {
                if(resp.status === 401) {
                    dispatch(setLoginExpired(true))
                    return Promise.resolve(ERROR_CODE.UNAUTHORISED_ACCESS)
                } else { 
                    dispatch(setLoginExpired(false))
                    let token = resp.headers.get(csrfTokenHeader)
                    dispatch(setCsrfToken(token))
                    return resp.json()
                }
            })
            .then(data => {
                if(data === ERROR_CODE.UNAUTHORISED_ACCESS) {
                    dispatch(setAccountInfoRequestStatus(REQUEST_STATUS.ERROR))
                    return Promise.reject(data)
                }

                dispatch(setUserData(data))
                dispatch(setAccountInfoRequestStatus(REQUEST_STATUS.SUCCESS))
                return data
            })
            .catch(error => {
                dispatch(setAccountInfoRequestStatus(REQUEST_STATUS.ERROR))
                return Promise.reject(error)
            })
}


export default userAuthSlice.reducer
